let Axios = axios.create({
    //baseURL: `${process.env.API_ROOT}`,
    //baseURL: `/api`,
    // timeout: 20000,
    withCredentials: true
})

Axios.interceptors.request.use(function(config) {
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'crossDomain': true
    }
    return config;
}, function(error) {
    // return alert("网络繁忙,请您稍后再试");
});
/**
 *直接返回数据层级 
 */
Axios.interceptors.response.use(data => {
    return data.data;
}, err => {
    if (err.response) {}
})
export default Axios


// WEBPACK FOOTER //
// ./src/base/axios/index.js